import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import ModalWrapper from 'dashboard/components/ModalWrapper';
import { ModalBody, ModalContainer, ModalFooter, ModalHeader } from 'dashboard/layouts/ModalLayout';
import Button from 'design-system/components/Button';
import { HStack } from 'design-system/components/Stack';
import { Paragraph } from 'design-system/components/Text';

const StyledModalBody = styled(ModalBody)`
  ${Paragraph} + ${Paragraph} {
    margin-top: ${Spacing[2]};
  }
`;

type ConfirmDeleteTransitionComponentModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  handleConfirmDelete: () => void;
};

const ConfirmDeleteTransitionComponentModal = ({
  isOpen,
  handleClose,
  handleConfirmDelete,
}: ConfirmDeleteTransitionComponentModalProps) => {
  return (
    <ModalWrapper isOpen={isOpen} handleCloseModal={handleClose}>
      <ModalContainer>
        <ModalHeader onClose={handleClose}>Delete this component?</ModalHeader>
        <StyledModalBody>
          <Paragraph>
            This component links to a section of your Flow. Deleting the component will disconnect
            this section.
          </Paragraph>
          <Paragraph>
            If you proceed, you won&apos;t see this section in Flow Editor. (You will still see the
            section&apos;s screens in Screen Editor, and can link to them from another component.)
          </Paragraph>
        </StyledModalBody>
        <ModalFooter>
          <HStack equal>
            <Button
              id='confirm-delete-transition-component__cancel'
              variant='basic'
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              id='confirm-delete-transition-component__confirm'
              variant='danger'
              onClick={handleConfirmDelete}
            >
              Delete
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContainer>
    </ModalWrapper>
  );
};

export default ConfirmDeleteTransitionComponentModal;
